import { apiTryFetchRetry } from '@editor/utils/apiFetchRetry';
import { Team } from '@repo/domain/team';

import { GenericApiResponse, TeamMemberInvite } from '../types';

import { USER_API_URL } from './constants';

type CreateTeamResponse = GenericApiResponse<{
  team: Team;
  token: string;
  invites?: TeamMemberInvite[];
}>;

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const createAPI = ({ url }: { url: string }) => {
  const requestUpgrade = async (): Promise<GenericApiResponse> => {
    return await apiTryFetchRetry<GenericApiResponse>(
      `${url}/request_upgrade`,
      { method: 'POST' }
    );
  };

  const create = async (
    name: string,
    emails?: string[]
  ): Promise<CreateTeamResponse> => {
    return await apiTryFetchRetry<CreateTeamResponse>(`${url}/create`, {
      method: 'POST',
      body: JSON.stringify({
        name,
        emails,
      }),
    });
  };

  return {
    requestUpgrade,
    create,
  };
};

export default createAPI({ url: `${USER_API_URL}/teams` });
